<template>
  <div>
    <div>
      <v-row>
        <v-col lg="4" cols="12">
          <v-card class="pa-5 ma-3" v-if="station.length !== 0" elevation="5">
            <v-card-title>
              <div>
                {{ keyword }} 平均工资 {{ describe.average }} 元
              </div>
              <div class="text-caption my-3 font-weight-light">{{ describe.text }}</div>
            </v-card-title>
            <v-divider></v-divider>
            <div>
              <div v-for="(item, index) in station" :key="index">
                <v-list-item height="50">
                  <v-list-item-avatar rounded color="grey">
                    <div class="avatar-txt-class">{{ item.label.slice(0, 1) }}</div>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                    <v-list-item-subtitle>{{ `平均工资${item.value}` }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="sendInfo(item)">
                      <v-icon color="red">
                        trending_up
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col lg="8" cols="12">
          <div class="ma-3" v-if="level.length !== 0">
            <v-card elevation="5">
              <v-card-title>
                人均平均工资
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text :style="{'height':`${size.height}px`}">
                <div ref="average" class="echarts-class"></div>
              </v-card-text>
            </v-card>
          </div>
          <div v-if="industry.length !== 0" class="ma-3">
            <v-card elevation="5">
              <v-card-title>
                行业平均工资
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text :style="{'height':`${size.height}px`}">
                <div ref="industry" class="echarts-class"></div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-dialog
          v-model="infoDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar>
            <v-btn
                icon
                @click="infoDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ infoTile }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div v-if="info" class="pa-3">
            <div class="pa-3">
              <v-card elevation="5">
                <v-card-title>
                  {{ infoTile }}平均工资
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text :style="{'height':`${size.height}px`}">
                  <div ref="level" class="echarts-class"></div>
                </v-card-text>
              </v-card>
            </div>
            <div class="pa-3">
              <v-card elevation="5">
                <v-card-title>
                  工作年限/平均工资
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text :style="{'height':`${size.height}px`}">
                  <div ref="workExperience" class="echarts-class"></div>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>


    <div>
      <v-dialog
          v-model="dialog"
          scrollable
          persistent
          width="400"
      >
        <v-card>
          <v-card-title>
            <div>
              <div class="mb-4">选择城市</div>
              <v-text-field
                  v-model="keyword"
                  label="Search"
                  placeholder="city"
                  outlined
                  dense
                  clearable
              ></v-text-field>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 400px;">
            <v-list dense>
              <v-list-item-group
                  v-model="selected"
                  color="primary"
              >
                <v-list-item
                    v-for="(item, i) in list"
                    :key="i"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
                color="blue darken-1"
                text
                @click="toHome()"
            >
              Close
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="submit"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import {data} from "@/components/city_data/data"
import {search, info} from '@/api/resources/salary'
import {Encrypt} from '@/utils/Aes';
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "index",
  data: () => ({
    infoTile: undefined,
    infoDialog: false,
    size: {
      height: undefined,
      width: undefined,
    },
    workExperienceChats: null,
    levelChats: null,
    industryChats: null,
    averageChats: null,
    dialog: true,
    cityList: data,
    selected: undefined,
    keyword: undefined,
    name: undefined,
    info: {},
    station: [],
    industry: [],
    level: [],
    describe: {}
  }),
  computed: {
    ...mapGetters(['getDarker']),
    list() {
      if (!this.keyword) {
        return this.cityList
      } else {
        return this.cityList.filter(item => {
          return item.name.replace(/(^\s*)|(\s*$)/g, "").toLowerCase().indexOf(this.keyword.replace(/(^\s*)|(\s*$)/g, "").toLowerCase()) !== -1
        })
      }
    },
    isModel() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
  },
  mounted() {
    this.size = {
      height: this.isModel ? this.$vuetify.breakpoint.height : this.$vuetify.breakpoint.height / 2,
      width: this.$vuetify.breakpoint.width
    }
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    onResize() {
      this.$nextTick(() => {
        if (this.averageChats && this.industryChats) {
          this.averageChats.resize();
          this.industryChats.resize();
        }
        if (this.workExperienceChats && this.levelChats) {
          this.workExperienceChats.resize();
          this.levelChats.resize();
        }
      })
    },
    sendInfo({param, label}) {
      this.setLoading();
      info({param: param}).then(response => {
        this.infoDialog = true;
        let {workExperience, level} = response.data.data;
        this.info = {
          level,
          workExperience
        }
        this.infoTile = label
        this.$nextTick(() => {
          this.creationLevel()
          this.creationWorkExperience()
        })
      }).finally(() => {
        this.clearLoading();
      })
    },
    _search() {
      this.setLoading();
      search({encryptStr: Encrypt(this.name)}).then(req => {
        let {industry, level, station, average, text} = req.data.data;
        this.level = level
        this.industry = industry
        this.station = station
        this.describe = {average, text}
        this.$nextTick(() => {
          this.creationAverage()
          this.creationIndustry()
        })
      }).finally(() => {
        this.clearLoading();
      })
    },
    submit() {
      if (typeof (this.selected) === "undefined") {
        return;
      }
      let _list = [...this.list];
      let {name} = _list [this.selected]
      this.name = name;
      this.keyword = undefined;
      this._search()
      this.dialog = false
    },
    creationWorkExperience() {
      let levelList = this.info.workExperience.map(item => item.level)

      let valueList = this.info.workExperience.map(item => item.value.replaceAll("￥", ""))

      let option = {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: [...levelList]
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [...valueList],
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      };
      this.$nextTick(() => {
        this.workExperienceChats = this.$echarts.init(this.$refs.workExperience, 'vintage', {renderer: 'canvas'})
        this.workExperienceChats.setOption(option);
        this.workExperienceChats.resize();
      })
    },
    creationLevel() {
      let list = []
      this.level.forEach(item => {
        list.push({
          value: item.value.replaceAll("%", ''),
          name: item.level
        })
      })

      let option = {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        title: {
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c5} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: this.infoTile,
            type: 'pie',
            radius: '50%',
            data: [...list],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      this.$nextTick(() => {
        this.levelChats = this.$echarts.init(this.$refs.level, 'vintage', {renderer: 'canvas'})
        this.levelChats.setOption(option);
        this.levelChats.resize();
      })
    },
    creationAverage() {
      let list = []
      this.level.forEach(item => {
        list.push({
          value: item.value.replaceAll("%", ''),
          name: item.level
        })
      })
      let option = {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c5} ({d}%)'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: '平均工资',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [...list]
          }
        ],
      };

      this.$nextTick(() => {
        this.averageChats = this.$echarts.init(this.$refs.average, 'vintage', {renderer: 'canvas'})
        this.averageChats.setOption(option);
        this.averageChats.resize();
      })
    },
    creationIndustry() {
      let list = []

      this.industry.forEach(item => {
        list.push({
          value: item.value,
          name: item.label
        })
      })

      let option = {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c5} 元'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: '行业',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [...list]
          }
        ],
      };

      this.$nextTick(() => {
        this.industryChats = this.$echarts.init(this.$refs.industry, 'vintage', {renderer: 'canvas'})
        this.industryChats.setOption(option);
        this.industryChats.resize();
      })
    },
    toHome() {
      this.$router.push({
        path: '/home',
      })
    }
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style scoped>
.echarts-class {
  height: 100%;
  width: 100%;
}

.avatar-txt-class {
  width: 100%;
  text-align: center;
}
</style>
